export default function activeRequests(state=0, { type, printing, props }) {
    if(type.startsWith("CLEAR_REQUESTS_") )
        return 0;
    if(type.startsWith("REQUEST_") )
        return state+1;
    if(type.startsWith("RESPONSE_") )
        return state-1;
    return state;
}